<template>
  <div class="container text-with-icon-tiles">
    <div class="text-with-icon-tiles__head">
      <!-- Cand titlul e imagine (font comercial exportat cu contururi din Figma),
           `title` ramane folosit ca text alternativ. -->
      <img
        v-if="title_image_src"
        class="text-with-icon-tiles__title-image"
        :src="title_image_src"
        :alt="title">
      <default-title
        v-else-if="title"
        class="text-with-icon-tiles__title"
        upper_case
        pre_wrap
        :title="title"
        :title_tag="title_tag"/>
      <span
        v-if="title_divider"
        class="text-with-icon-tiles__title-divider"/>
      <html-block
        v-if="intro"
        class="text-with-icon-tiles__intro"
        :content="intro"/>
    </div>

    <div class="text-with-icon-tiles__row">
      <html-block
        v-if="col_left"
        class="text-with-icon-tiles__column text-with-icon-tiles__column_left"
        :content="col_left"/>
      <html-block
        v-if="col_right"
        class="text-with-icon-tiles__column text-with-icon-tiles__column_right"
        :content="col_right"/>

      <div class="text-with-icon-tiles__grid">
        <component
          v-for="(tile, index) in tiles"
          :is="tile.link ? 'a' : 'div'"
          :href="tile.link || null"
          :key="`icon-tile_${index}`"
          class="text-with-icon-tiles__item">
          <div
            v-if="tile.label"
            class="text-with-icon-tiles__label">{{ tile.label }}</div>
          <div
            class="text-with-icon-tiles__tile"
            :class="`text-with-icon-tiles__tile_${tile.theme || 'light'}`">
            <img
              v-if="tile.icon_src"
              class="text-with-icon-tiles__icon"
              :src="tile.icon_src"
              :alt="tile.label || 'icon'">
          </div>
        </component>
      </div>
    </div>
  </div>
</template>

<script>
import DefaultTitle from "../small_parts/DefaultTitle.vue";
import HtmlBlock from "../small_parts/HtmlBlock";

export default {
  name: "TextWithIconTiles",
  components: {HtmlBlock, DefaultTitle},
  // Sectiunea unica din mijlocul paginii B2B: titlu, un text de intro pe toata latimea,
  // apoi trei coloane — lista "IF YOU HAVE", pasii cu caseta LOCATION, si dalele de
  // categorii. A adunat la un loc "Who NOZ is?" si "The business concept", care erau
  // doua blocuri separate; titlul celui de-al doilea a disparut cu totul.
  //
  // Blocurile nu se pot imbrica in page builder — `pages_builder` e o tabela plata,
  // fara coloana de parinte, iar layout-ul randeaza un `v-for` simplu. De aceea o
  // sectiune cu trei coloane e o singura componenta, nu un container cu blocuri inauntru.
  //
  // Notele despre propuri nu pot sta intre marcajele de mai jos: parserul citeste tot
  // ce e acolo ca JSON, iar o linie de comentariu il face sa cedeze tacit si componenta
  // ajunge in page builder fara niciun camp editabil.
  //
  // `admin_text` da campului o eticheta lizibila in admin, in locul numelui brut al
  // propului (BuilderVariableItem.vue: `admin_text || var_name`). Aici conteaza:
  // fara eticheta nimic nu spune care camp ajunge in ce coloana. Etichetele nu pot
  // contine doua puncte — parserul imparte linia dupa ele.
  props: {
    /**props**/
    title: {
      type: String,
      default: '',
      admin_text: 'Title',
      admin_type: 'input',
    },
    title_image_src: {
      type: String,
      default: '',
      admin_text: 'Title as image (optional)',
      admin_type: 'image',
    },
    title_tag: {
      type: String,
      default: 'h2',
      admin_text: 'Title tag',
      admin_type: 'select',
      admin_data_values: [
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
      ],
    },
    title_divider: {
      type: Boolean,
      default: false,
      admin_text: 'Line under the title',
      admin_type: 'checkbox',
    },
    intro: {
      type: String,
      default: '',
      admin_text: 'Intro - spans all three columns',
      admin_type: 'editor',
    },
    col_left: {
      type: String,
      default: '',
      admin_text: 'Column 1 - content',
      admin_type: 'editor',
    },
    col_right: {
      type: String,
      default: '',
      admin_text: 'Column 2 - content',
      admin_type: 'editor',
    },
    tiles: {
      type: Array,
      default: () => [],
      admin_text: 'Column 3 - tiles',
      admin_type: 'array',
      array_values: {
        icon_src: {
          type: String,
          default: '',
          admin_text: 'Icon',
          admin_type: 'image',
        },
        label: {
          type: String,
          default: '',
          admin_text: 'Label above the icon',
          admin_type: 'input',
        },
        theme: {
          type: String,
          default: 'light',
          admin_text: 'Tile background',
          admin_type: 'select',
          admin_data_values: [
            'light',
            'dark'
          ],
        },
        link: {
          type: String,
          default: '',
          admin_text: 'Link (optional)',
          admin_type: 'input',
        },
      }
    },
    /**props**/
  }
}
</script>
